import { progettiImages, residenzeImages, retailImages } from './images';
import type { Project, ProjectCategory } from './types';

/**
 * NB: titoli, luoghi e anni sono PLACEHOLDER plausibili per la demo.
 * Vanno confermati / corretti con Silvana prima della messa online.
 * Le immagini sono invece reali, prese dal sito attuale.
 */
export const projects: Project[] = [
  {
    slug: 'villa-sul-lago',
    title: 'Villa sul Lago',
    titleEn: 'Lakeside Villa',
    category: 'residenze',
    year: '2023',
    location: 'Lago Maggiore',
    summary:
      'Una residenza affacciata sull’acqua: luce, materia e silenzio. Finiture su misura e arredi disegnati per il luogo.',
    summaryEn:
      'A residence facing the water: light, material and silence. Bespoke finishes and furniture designed for the place.',
    cover: residenzeImages[0] ?? '',
    images: residenzeImages.slice(0, 4),
  },
  {
    slug: 'attico-liberty',
    title: 'Attico Liberty',
    titleEn: 'Liberty Penthouse',
    category: 'residenze',
    year: '2022',
    location: 'Varese',
    summary:
      'Un attico dove il dettaglio storico incontra una palette contemporanea. Equilibrio tra memoria e gesto nuovo.',
    summaryEn:
      'A penthouse where historic detail meets a contemporary palette. Balance between memory and a new gesture.',
    cover: residenzeImages[4] ?? '',
    images: residenzeImages.slice(4, 8),
  },
  {
    slug: 'casa-di-charme',
    title: 'Casa di Charme',
    titleEn: 'House of Charme',
    category: 'residenze',
    year: '2021',
    location: 'Lombardia',
    summary:
      'Spazi domestici pensati come ritratto di chi li abita. Tessuti, ottoni e legni in dialogo caldo.',
    summaryEn:
      'Domestic spaces conceived as a portrait of those who live in them. Fabrics, brass and woods in a warm dialogue.',
    cover: residenzeImages[8] ?? '',
    images: residenzeImages.slice(8, 12),
  },
  {
    slug: 'boutique',
    title: 'Boutique',
    titleEn: 'Boutique',
    category: 'retail',
    year: '2023',
    location: 'Varese',
    summary:
      'Un retail concepito come esperienza: percorsi, luce e materia che mettono in scena il prodotto.',
    summaryEn:
      'Retail conceived as an experience: paths, light and material that stage the product.',
    cover: retailImages[0] ?? '',
    images: retailImages.slice(0, 4),
  },
  {
    slug: 'spazio-horeca',
    title: 'Spazio Horeca',
    titleEn: 'Horeca Space',
    category: 'retail',
    year: '2022',
    location: 'Lombardia',
    summary:
      'Ristorazione e ospitalità: atmosfere costruite con luce calda, superfici tattili e una regia degli spazi.',
    summaryEn:
      'Hospitality and dining: atmospheres built with warm light, tactile surfaces and a direction of space.',
    cover: retailImages[4] ?? '',
    images: retailImages.slice(4, 7),
  },
  {
    slug: 'residenza-contemporanea',
    title: 'Residenza Contemporanea',
    titleEn: 'Contemporary Residence',
    category: 'progetti',
    year: '2025',
    location: 'In corso',
    summary:
      'Progetto in corso: una residenza dal segno netto, in cui ogni stanza è un capitolo della stessa storia.',
    summaryEn:
      'Work in progress: a residence with a clear sign, where each room is a chapter of the same story.',
    cover: progettiImages[0] ?? '',
    images: progettiImages.slice(0, 7),
  },
  {
    slug: 'nuovo-cantiere',
    title: 'Nuovo Cantiere',
    titleEn: 'New Site',
    category: 'progetti',
    year: '2025',
    location: 'In corso',
    summary:
      'Dallo studio di fattibilità alle finiture: un cantiere seguito passo dopo passo, fino alla casa dei sogni.',
    summaryEn:
      'From feasibility study to finishes: a site followed step by step, all the way to the dream home.',
    cover: progettiImages[7] ?? '',
    images: progettiImages.slice(7, 13),
  },
];

export const categoryLabels: Record<ProjectCategory, { it: string; en: string }> = {
  residenze: { it: 'Residenze', en: 'Residences' },
  retail: { it: 'Retail', en: 'Retail' },
  progetti: { it: 'Progetti in corso', en: 'In progress' },
};

export function getProject(slug: string | undefined): Project | undefined {
  return projects.find((p) => p.slug === slug);
}
